import MisCotizaciones from "../../components/MisCotizaciones";

const MisCotizacionesPage = () => <MisCotizaciones />;

export default MisCotizacionesPage;
